import request from '../../request'

export default {
  actions: {
    getRenewAccount() {
      return request.get('renew-account');
    },

    getInvoiceAddresses () {
      return request.get('invoice-addresses')
    },

    createInvoiceAddress (_, payload) {
      return request.post('invoice-addresses', payload)
    },

    // update service
    updateInvoiceAddress (_, payload) {
      return request.put('invoice-addresses/' + payload.id, payload)
    },

    // delete service
    deleteInvoiceAddress (_, id) {
      return request.delete('invoice-addresses/' + id)
    },
  }
}
